import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// constants
import { Forms } from 'constants/index'
// views
import { ActivityActionsWrapper, OptionWrapper, CommentIcon, DeleteIcon, EditIcon } from './views'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'
import { ActivitiesListBLContext } from 'containers/Activities/layers/BL/ActivitiesList'
import { ActivityBLContext } from 'containers/Activities/layers/BL/Activity'
// types
import { LogEntityTypes } from 'types/graphql'

interface Props {
  isOwnActivity: boolean
}

const ActivityActionsMenu: React.FC<Props> = ({ isOwnActivity }) => {
  const { canModifyResource, canDeleteResource, refetch } = React.useContext(ActivitiesListAPIContext)
  const { activity, handleAddSubComment, handleEditComment } = React.useContext(ActivityBLContext)
  const { handleDeleteClick, handleEditClick, isReviewDetails, isSubActivities } =
    React.useContext(ActivitiesListBLContext)

  const dispatch = useDispatch()

  const isImage: boolean = activity.entityType === LogEntityTypes.Image
  const isLink: boolean = activity.entityType === LogEntityTypes.Link
  const isResource: boolean = activity.entityType === LogEntityTypes.Resource
  const isComment: boolean = activity.entityType === LogEntityTypes.Comment

  const shouldShowEditButton: boolean = isLink || isImage || isComment || (isResource && canModifyResource)
  const shouldShowCommentButton: boolean = !isResource && !isSubActivities && !isReviewDetails

  const addComment = () => {
    handleAddSubComment()
  }

  const deleteActivity = () => {
    handleDeleteClick(activity, refetch)
  }

  const editActivity = () => {
    if (isComment) {
      handleEditComment()
      dispatch(change(Forms.EDIT_COMMENT_FORM, 'content', activity.metadata.comment))
      dispatch(change(Forms.EDIT_COMMENT_FORM, 'activityId', activity.id))
      return
    }

    handleEditClick(activity)
  }

  return (
    <ActivityActionsWrapper>
      {shouldShowCommentButton && (
        <OptionWrapper onClick={addComment}>
          <CommentIcon />
        </OptionWrapper>
      )}

      {(canDeleteResource || !isResource) && isOwnActivity && (
        <OptionWrapper onClick={deleteActivity}>
          <DeleteIcon />
        </OptionWrapper>
      )}

      {shouldShowEditButton && isOwnActivity && (
        <OptionWrapper onClick={editActivity}>
          <EditIcon />
        </OptionWrapper>
      )}
    </ActivityActionsWrapper>
  )
}

export default ActivityActionsMenu
